import type { ILinkReplaceRule } from '@carboncopyco/types';
import type { IFindAndReplaceRuleState } from '../types';
import { EditControls } from './EditControls';

export type TextReplaceControlsProps = Pick<
  IFindAndReplaceRuleState<ILinkReplaceRule>,
  | 'onSubmit'
  | 'submitting'
  | 'rule'
  | 'rules'
  | 'onCancel'
  | 'autoFocus'
  | 'onFocus'
>;
export const LinkReplaceControls = ({
  onSubmit,
  rule,
  onCancel,
  autoFocus,
  onFocus,
}: TextReplaceControlsProps) => {
  if (rule) {
    return (
      <EditControls
        onSubmit={onSubmit}
        rule={rule}
        onCancel={onCancel}
        onFocus={onFocus}
        autoFocus={autoFocus}
      />
    );
  }

  // We don't support creation of link F&R rules from the manager.
  // The manager can only instruct the engine to initiate the creation flow.
  return null;
};
